import Button from 'components/Button'
import { addModal, clearAllModals } from 'features/modals/modalSlice'
import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { colors, _ } from 'utils'
import ImportDataForm from './ImportDataForm'
import { ImportDataFormProps, ImportErrors } from './types'
import { downloadErrorsFile } from './utils'

const S = {
    Description: styled.p`
        font-size: 16px;
        color: ${colors.grayDescription};
        font-weight: 300;
        margin-bottom: 24px;
    `,
    Error: styled.p`
        font-size: 14px;
        line-height: 16px;
        color: ${colors.icon};
        margin-bottom: 8px;
    `,
    Actions: styled.div`
        display: flex;
        justify-content: space-between;
        margin-top: 32px;
    `,
}

interface Props {
    errorsFE?: ImportErrors
    errorsBE?: string[]
    errorClose: () => void
    onSubmit?: (data: Record<string, string>[]) => void
    importProps?: Omit<ImportDataFormProps, 'onSubmit'>
}

const ValidationErrorList = ({
    errorsFE=[], errorsBE=[], errorClose, onSubmit, importProps
}: Props) => {
    const dispatch = useDispatch()
    const handleImportAgain = () => {
        dispatch(clearAllModals())
        dispatch(addModal({
            header: _('list.import_header'),
            Component: ({ close }: { close: () => void }) => (
                <ImportDataForm {...importProps} onSubmit={onSubmit} close={close} />
            ),
            backdrop: 'static'
        }))
    }
    const downloadErrors = () => {
        let errors = []
        if (errorsFE.length) {
            errors = errorsFE.map((e) => {
                let field = e.field
                if (field === 'End Time') {
                    field = 'Combination of End Date and End Time'
                }

                return `At row ${+e.row + 2}, ${field} value is incorrect. (${e.detail})`
            })
        }
        if (errorsBE.length) {
            errors = [
                'The server can not process data at these items below. Please check again.',
                ...errorsBE
            ]
        }
        downloadErrorsFile(errors)
    }

    return (
        <div>
            <S.Description>{_('import_file.error_list_description')}</S.Description>
            {errorsFE.map((e) => {
                let field = e.field
                if (field === 'End Time') {
                    field = 'Combination of End Date and End Time'
                }

                return (
                    <S.Error>
                        At
                        {' '}
                        <strong>{`row ${+e.row + 2}, ${field} value`}</strong>
                        {` is incorrect. (${e.detail})`}
                    </S.Error>
                )
            })}
            {!!errorsBE.length && (
                <S.Description>
                    The server can not process data at these items below. Please check again.
                </S.Description>
            )}
            <S.Error>
                <strong>{errorsBE.join(',  ')}</strong>
            </S.Error>
            <S.Actions>
                <div className="d-flex">
                    <Button variant="secondary" onClick={errorClose} style={{ marginRight: 20 }}>
                        {_('button.close')}
                    </Button>
                    <Button variant="secondary" onClick={downloadErrors} style={{ marginRight: 20 }}>
                        {_('import_file.download_errors_button')}
                    </Button>
                </div>
                {onSubmit && (
                    <Button variant="primary" onClick={handleImportAgain}>
                        {_('import_field.import_again_button')}
                    </Button>
                )}
            </S.Actions>
        </div>
    )
}

export default ValidationErrorList
